(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atlas-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atlas-slideshow')) {
    customElements.define('atlas-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.atlas-slide')];
        if (this.slides.length < 2 || this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.atlas-slideshow-track');
        this.dots = [...this.querySelectorAll('[data-slide-to]')];
        this.toggle = this.querySelector('[data-toggle]');
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.paused = this.dataset.autoplay !== 'true' || this.motion.matches;
        this.hovered = false;
        this.focused = false;
        this.visible = true;
        this.delay = Math.max(4000, Number(this.dataset.delay) || 6000);
        this.querySelector('.atlas-slideshow-controls').hidden = false;
        this.querySelector('[data-previous]').addEventListener('click', () => this.goTo(this.index - 1, true), options);
        this.querySelector('[data-next]').addEventListener('click', () => this.goTo(this.index + 1, true), options);
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index, true), options));
        this.toggle.addEventListener('click', () => {
          this.paused = !this.paused;
          if (!this.paused) this.focused = false;
          this.updateToggle();
          this.schedule();
        }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) this.paused = true;
          this.updateToggle();
          this.schedule();
        }, options);
        document.addEventListener('shopify:block:select', event => {
          const selected = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (selected >= 0) this.goTo(selected, true);
        }, options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.updateToggle();
        this.goTo(0);
      }
      goTo(index, manual = false) {
        this.index = (index + this.slides.length) % this.slides.length;
        if (manual) { this.paused = true; this.updateToggle(); }
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        this.slides.forEach((slide, number) => {
          slide.inert = number !== this.index;
          slide.setAttribute('aria-hidden', String(number !== this.index));
        });
        this.dots.forEach((dot, number) => {
          if (number === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.querySelector('[data-slide-counter]').textContent = String(this.index + 1).padStart(2, '0');
        if (manual) this.querySelector('[data-slide-status]').textContent = this.slides[this.index].getAttribute('aria-label');
        this.schedule();
      }
      updateToggle() {
        this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
        this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
      }
      schedule() {
        clearTimeout(this.timer);
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden) this.timer = setTimeout(() => this.goTo(this.index + 1), this.delay);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-van-designer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-designer-config]').textContent);
    const t = key => config.text[key] || key;
    const $ = selector => root.querySelector(selector);
    const $$ = selector => [...root.querySelectorAll(selector)];
    const ns = 'http://www.w3.org/2000/svg';
    const types = {
      kitchen:{l:1200,w:550,h:850,z:0},
      bed:{l:1400,w:1750,h:480,z:0},
      shower:{l:700,w:700,h:1800,z:0},
      locker:{l:1000,w:330,h:350,z:1450},
      bench:{l:1100,w:500,h:450,z:0},
      wardrobe:{l:600,w:500,h:1650,z:0}
    };
    const finishes = {sage:'#9da68f',sand:'#d6c7ac',white:'#f0efe7',charcoal:'#454946',orange:'#d47142'};
    const presets = {compact:[2500,1700,1350],medium:[3500,1800,1900],long:[4300,1800,1900]};
    const fresh = () => ({version:1,van:'medium',length:3500,width:1800,height:1900,finish:'sage',floor:'oak',items:[
      {id:1,type:'bed',l:1400,w:1750,h:480,z:0,x:30,y:20},
      {id:2,type:'kitchen',l:1200,w:550,h:850,z:0,x:1700,y:0},
      {id:3,type:'locker',l:1100,w:330,h:350,z:1450,x:1700,y:0},
      {id:4,type:'wardrobe',l:600,w:500,h:1650,z:0,x:2600,y:1300}
    ]});
    let state=fresh(),selected=2,view='3d',angle=145,projection=null,drag=null,toastTimer;
    const svg=$('[data-scene]');
    const el=(name,attrs={},parent=svg)=>{const n=document.createElementNS(ns,name);for(const[k,v]of Object.entries(attrs))n.setAttribute(k,v);parent.append(n);return n;};
    const textNode=(parent,str,attrs)=>{const n=el('text',attrs,parent);n.textContent=str;return n;};
    const toast=message=>{const n=$('[data-toast]');n.textContent=message;n.hidden=false;clearTimeout(toastTimer);toastTimer=setTimeout(()=>{n.hidden=true;},5000);};
    const tone=(hex,factor)=>'#'+hex.slice(1).match(/../g).map(x=>Math.min(255,Math.round(parseInt(x,16)*factor)).toString(16).padStart(2,'0')).join('');
    const getSelected=()=>state.items.find(x=>x.id===selected);
    const productVariants=()=>config.product?.variants||[];
    const formatMoney=cents=>new Intl.NumberFormat(config.locale||'en-GB',{style:'currency',currency:config.currency||'GBP'}).format(cents/100);
    const validate=value=>{
      if(!value||value.version!==1||!['compact','medium','long','custom'].includes(value.van)||!Object.hasOwn(finishes,value.finish)||!['oak','grey','dark'].includes(value.floor)||!Array.isArray(value.items)||value.items.length>28)throw Error('invalid');
      const numeric=(v,min,max)=>typeof v==='number'&&Number.isFinite(v)&&v>=min&&v<=max;
      if(!numeric(value.length,1500,5500)||!numeric(value.width,1200,2300)||!numeric(value.height,1100,2500))throw Error('invalid');
      const items=value.items.map((u,i)=>{if(!Object.hasOwn(types,u.type))throw Error('invalid');for(const[k,min,max]of [['l',100,5000],['w',100,2300],['h',100,2500],['x',0,5500],['y',0,2300],['z',0,2400]])if(!numeric(u[k],min,max))throw Error('invalid');return{id:i+1,type:u.type,l:u.l,w:u.w,h:u.h,x:u.x,y:u.y,z:u.z};});
      return{version:1,van:value.van,length:value.length,width:value.width,height:value.height,finish:value.finish,floor:value.floor,items};
    };
    const encode=value=>btoa(unescape(encodeURIComponent(JSON.stringify(value))));
    const decode=value=>JSON.parse(decodeURIComponent(escape(atob(value))));
    try{const match=location.hash.match(/^#atlas-plan=([\w+/=]+)$/);if(match&&match[1].length<18000){state=validate(decode(match[1]));selected=state.items[0]?.id;}}catch{toast(t('invalid_plan'));}
    const warnings=()=>{
      const result=[];
      for(const u of state.items)if(u.x+u.l>state.length||u.y+u.w>state.width||u.z+u.h>state.height)result.push(t(u.type)+' — '+t('outside'));
      for(let i=0;i<state.items.length;i++)for(let j=i+1;j<state.items.length;j++){
        const a=state.items[i],b=state.items[j];
        if(a.x<b.x+b.l&&a.x+a.l>b.x&&a.y<b.y+b.w&&a.y+a.w>b.y&&a.z<b.z+b.h&&a.z+a.h>b.z)result.push(t(a.type)+' / '+t(b.type)+' — '+t('overlap'));
      }
      return result;
    };
    const setupProjection=()=>{
      const r=angle*Math.PI/180,c=Math.cos(r),s=Math.sin(r),flatten=view==='plan'?1:.48;
      const raw=(x,y,z=0)=>view==='plan'?[x,y]:[x*c-y*s,(x*s+y*c)*flatten-z*.86];
      const corners=[];
      for(const x of [0,state.length+650])for(const y of [0,state.width])for(const z of [0,view==='plan'?0:state.height])corners.push(raw(x,y,z));
      const xs=corners.map(p=>p[0]),ys=corners.map(p=>p[1]);
      const minX=Math.min(...xs),maxX=Math.max(...xs),minY=Math.min(...ys),maxY=Math.max(...ys);
      const scale=Math.min(760/(maxX-minX),465/Math.max(1,maxY-minY));
      const ox=450-(maxX+minX)/2*scale,oy=320-(maxY+minY)/2*scale;
      projection={scale,ox,oy};
      return (x,y,z=0)=>{const p=raw(x,y,z);return[p[0]*scale+ox,p[1]*scale+oy];};
    };
    const renderScene=()=>{
      const focused=svg.contains(document.activeElement)?document.activeElement?.dataset?.id:null;
      svg.replaceChildren();svg.dataset.plan=view==='plan';
      const p=setupProjection(),points=vertices=>vertices.map(v=>p(...v).join(',')).join(' ');
      const polygon=(vertices,attrs={},parent=svg)=>el('polygon',{points:points(vertices),...attrs},parent);
      const line=(a,b,attrs={},parent=svg)=>{const x=p(...a),y=p(...b);return el('line',{x1:x[0],y1:x[1],x2:y[0],y2:y[1],...attrs},parent);};
      const floor=state.floor==='oak'?'#c7b394':state.floor==='grey'?'#b5b6b1':'#565b56';
      polygon([[0,0,0],[state.length+630,0,0],[state.length+630,state.width,0],[0,state.width,0]],{fill:'#d5d6ce',stroke:'#9b9f94','stroke-width':2});
      polygon([[0,0,4],[state.length,0,4],[state.length,state.width,4],[0,state.width,4]],{fill:floor,stroke:'#81867c','stroke-width':1.5});
      for(let y=150;y<state.width;y+=150)line([0,y,5],[state.length,y,5],{stroke:tone(floor,.86),'stroke-width':.6});
      line([state.length,0,6],[state.length,state.width,6],{stroke:'#81867c','stroke-width':2,'stroke-dasharray':'6 5'});
      if(view==='3d'){
        for(const [x,y]of [[0,0],[0,state.width],[state.length,0],[state.length,state.width]])line([x,y,0],[x,y,state.height],{stroke:'#9a9f92','stroke-width':1,'stroke-dasharray':'4 5',opacity:.5});
        polygon([[0,0,state.height],[state.length,0,state.height],[state.length,state.width,state.height],[0,state.width,state.height]],{fill:'none',stroke:'#9a9f92','stroke-width':1,'stroke-dasharray':'4 5',opacity:.5});
      }
      const box=(x,y,z,l,w,h,color,parent,stroke='#303c303d')=>{
        if(view==='plan'){polygon([[x,y,0],[x+l,y,0],[x+l,y+w,0],[x,y+w,0]],{fill:color,stroke,'stroke-width':1.2},parent);return;}
        const faces=[
          {v:[[x,y,z],[x+l,y,z],[x+l,y,z+h],[x,y,z+h]],c:tone(color,.75)},
          {v:[[x+l,y,z],[x+l,y+w,z],[x+l,y+w,z+h],[x+l,y,z+h]],c:tone(color,.86)},
          {v:[[x+l,y+w,z],[x,y+w,z],[x,y+w,z+h],[x+l,y+w,z+h]],c:tone(color,.82)},
          {v:[[x,y+w,z],[x,y,z],[x,y,z+h],[x,y+w,z+h]],c:tone(color,.73)}
        ];
        const r=angle*Math.PI/180;
        faces.sort((a,b)=>{const depth=f=>f.v.reduce((s,v)=>s+v[0]*Math.sin(r)+v[1]*Math.cos(r),0)/4;return depth(a)-depth(b);});
        for(const f of faces)polygon(f.v,{fill:f.c,stroke,'stroke-width':.6},parent);
        polygon([[x,y,z+h],[x+l,y,z+h],[x+l,y+w,z+h],[x,y+w,z+h]],{fill:color,stroke,'stroke-width':.8},parent);
      };
      const seats=el('g',{'aria-hidden':'true'});
      for(const y of [160,state.width-610]){box(state.length+100,y,0,420,450,340,'#5d625b',seats);box(state.length+100,y,340,110,450,450,'#70766c',seats);}
      const r=angle*Math.PI/180;
      const sorted=[...state.items].sort((a,b)=>view==='plan'?a.z-b.z:(a.x+a.l/2)*Math.sin(r)+(a.y+a.w/2)*Math.cos(r)-(b.x+b.l/2)*Math.sin(r)-(b.y+b.w/2)*Math.cos(r));
      for(const u of sorted){
        const g=el('g',{'data-id':u.id,tabindex:'0',role:'button','aria-label':t(u.type)+', '+u.l+' × '+u.w+' × '+u.h+' mm','aria-pressed':u.id===selected});
        const fill=finishes[state.finish];
        box(u.x,u.y,u.z,u.l,u.w,u.h,fill,g);
        if(u.type==='bed'||u.type==='bench'){
          box(u.x+22,u.y+22,u.z+u.h*.76,Math.max(50,u.l-44),Math.max(50,u.w-44),u.h*.24,'#e5e3d7',g);
          if(u.type==='bed')for(const y of [u.y+u.w*.1,u.y+u.w*.55])box(u.x+60,y,u.z+u.h,u.l*.2,u.w*.32,55,'#eeece3',g);
        }else if(u.type==='kitchen'){
          box(u.x-10,u.y-8,u.z+u.h-25,u.l+20,u.w+16,25,'#e3d8c2',g);
          polygon([[u.x+u.l*.1,u.y+u.w*.2,u.z+u.h+2],[u.x+u.l*.4,u.y+u.w*.2,u.z+u.h+2],[u.x+u.l*.4,u.y+u.w*.8,u.z+u.h+2],[u.x+u.l*.1,u.y+u.w*.8,u.z+u.h+2]],{fill:'#5c6662',stroke:'#c8cec5','stroke-width':2},g);
          polygon([[u.x+u.l*.62,u.y+u.w*.2,u.z+u.h+2],[u.x+u.l*.9,u.y+u.w*.2,u.z+u.h+2],[u.x+u.l*.9,u.y+u.w*.8,u.z+u.h+2],[u.x+u.l*.62,u.y+u.w*.8,u.z+u.h+2]],{fill:'#353c38'},g);
          for(const frac of [.3,.65])line([u.x+u.l*frac,u.y+u.w+2,u.z+40],[u.x+u.l*frac,u.y+u.w+2,u.z+u.h-35],{stroke:'#52604d','stroke-width':1},g);
          for(const frac of [.18,.49,.82])line([u.x+u.l*frac-45,u.y+u.w+3,u.z+u.h-100],[u.x+u.l*frac+45,u.y+u.w+3,u.z+u.h-100],{stroke:'#2c332c','stroke-width':2},g);
        }else if(u.type==='shower'){
          polygon([[u.x+25,u.y+25,u.z+u.h+2],[u.x+u.l-25,u.y+25,u.z+u.h+2],[u.x+u.l-25,u.y+u.w-25,u.z+u.h+2],[u.x+25,u.y+u.w-25,u.z+u.h+2]],{fill:'#c3d4d2',opacity:.8},g);
        }else{
          line([u.x+u.l/2,u.y+u.w+2,u.z+20],[u.x+u.l/2,u.y+u.w+2,u.z+u.h-20],{stroke:'#53604e','stroke-width':1},g);
          line([u.x+u.l/2-50,u.y+u.w+3,u.z+u.h*.55],[u.x+u.l/2-50,u.y+u.w+3,u.z+u.h*.7],{stroke:'#263024','stroke-width':2},g);
        }
        if(view==='plan'){
          const pos=p(u.x+u.l/2,u.y+u.w/2);
          textNode(g,t(u.type),{x:pos[0],y:pos[1]+3,'text-anchor':'middle','font-size':Math.max(10,Math.min(15,u.l*projection.scale/8)),fill:'#252d23','font-weight':'700','paint-order':'stroke',stroke:'#ffffffc0','stroke-width':3});
          if(u.z>0)polygon([[u.x,u.y,0],[u.x+u.l,u.y,0],[u.x+u.l,u.y+u.w,0],[u.x,u.y+u.w,0]],{fill:'none',stroke:'#fff','stroke-width':2,'stroke-dasharray':'5 4'},g);
        }
        if(u.id===selected)polygon([[u.x,u.y,u.z+u.h+65],[u.x+u.l,u.y,u.z+u.h+65],[u.x+u.l,u.y+u.w,u.z+u.h+65],[u.x,u.y+u.w,u.z+u.h+65]],{fill:'none',stroke:'#ee6c23','stroke-width':2.5,'stroke-linejoin':'round'},g);
      }
      const rear=p(0,state.width/2),cab=p(state.length+560,state.width/2);
      textNode(svg,t('rear'),{x:rear[0]-25,y:rear[1]+28,'font-size':10,fill:'#626b5d','text-anchor':'middle','font-weight':700});
      textNode(svg,t('cab'),{x:cab[0]+18,y:cab[1]+24,'font-size':10,fill:'#626b5d','text-anchor':'middle','font-weight':700});
      if(focused)svg.querySelector('[data-id="'+focused+'"]')?.focus({preventScroll:true});
    };
    const render=()=>{
      for(const key of ['van','length','width','height','floor'])$('[data-field="'+key+'"]').value=state[key];
      $$('[data-finish]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.finish===state.finish));
      $('[data-finish-name]').textContent=t(state.finish);
      $$('[data-action="3d"],[data-action="plan"]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.action===view));
      $$('[data-action="rotate-left"],[data-action="rotate-right"]').forEach(b=>{b.disabled=view==='plan';});
      $('[data-stage-dimensions]').textContent=state.length+' × '+state.width+' × '+state.height+' mm';
      $('[data-stage-hint]').textContent=t(view==='plan'?'drag_hint':'view_hint');
      $('[data-unit-count]').textContent='('+state.items.length+')';
      const list=$('[data-build-list]');list.replaceChildren();
      state.items.forEach(u=>{const b=document.createElement('button');b.type='button';b.textContent=t(u.type);b.dataset.select=u.id;b.setAttribute('aria-pressed',u.id===selected);list.append(b);});
      if(!state.items.length)list.textContent=t('empty_hint');
      const unit=getSelected();$('[data-selected-controls]').hidden=!unit;
      $('[data-selected-title]').textContent=unit?t(unit.type):t('nothing_selected');
      $('[data-selection-hint]').textContent=t(unit?'selection_hint':'click_hint');
      if(unit)for(const key of ['l','w','h','z','x','y'])$('[data-unit="'+key+'"]').value=unit[key];
      const w=warnings(),warning=$('[data-warnings]');warning.textContent=w.length?w.join(' · '):t('clear');warning.dataset.clear=!w.length;
      renderScene();
    };
    const buildSummary=()=>[
      'ATLAS DISTRIBUTIONS — '+t('summary'),
      t('space')+': '+t(state.van)+' | '+state.length+' × '+state.width+' × '+state.height+' mm',
      t('finish')+': '+t(state.finish)+' | '+t('floor')+': '+t(state.floor),
      '',...state.items.map((u,i)=>(i+1)+'. '+t(u.type)+' | '+u.l+' × '+u.w+' × '+u.h+' mm | '+t('position')+': x '+u.x+', y '+u.y+', z '+u.z+' mm'),
      '',t('quote_required'),t('footnote'),
      ...warnings().map(w=>t('check')+': '+w)
    ].join('\n');
    const copy=async value=>{
      if(navigator.clipboard&&window.isSecureContext){await navigator.clipboard.writeText(value);return;}
      const area=document.createElement('textarea');area.value=value;area.style.position='fixed';area.style.left='-9999px';root.append(area);area.select();const ok=document.execCommand('copy');area.remove();if(!ok)throw Error('copy');
    };
    const add=type=>{
      if(state.items.length>=28){toast(t('max_items'));return;}
      const d=types[type],u={id:Math.max(0,...state.items.map(x=>x.id))+1,type,...d,x:0,y:0};
      u.l=Math.min(u.l,state.length);u.w=Math.min(u.w,state.width);u.h=Math.min(u.h,state.height);u.z=Math.min(u.z,state.height-u.h);
      let found=false;
      for(let x=0;x<=state.length-u.l&&!found;x+=100)for(let y=0;y<=state.width-u.w&&!found;y+=100){
        if(!state.items.some(a=>x<a.x+a.l&&x+u.l>a.x&&y<a.y+a.w&&y+u.w>a.y&&u.z<a.z+a.h&&u.z+u.h>a.z)){u.x=x;u.y=y;found=true;}
      }
      state.items.push(u);selected=u.id;render();toast(t(type)+' '+t('added'));
    };
    Object.keys(types).forEach(type=>{
      const b=document.createElement('button');b.type='button';b.dataset.add=type;b.setAttribute('aria-label',t('add')+' '+t(type));
      const icon=document.createElementNS(ns,'svg');icon.setAttribute('viewBox','0 0 48 36');icon.setAttribute('aria-hidden','true');
      el('path',{d:'M5 12 27 4 43 12 21 21Z',fill:'#c2c9b8',stroke:'#52634b'},icon);el('path',{d:'M5 12v14l16 7V21Z',fill:'#8d9a80',stroke:'#52634b'},icon);el('path',{d:'M21 21v12l22-9V12Z',fill:'#a5b298',stroke:'#52634b'},icon);
      if(type==='bed'||type==='bench')el('path',{d:'M7 12 27 6 41 12 21 19Z',fill:'#f4f2e8'},icon);
      if(type==='kitchen')el('ellipse',{cx:24,cy:11,rx:7,ry:3,fill:'#627061'},icon);
      const label=document.createElement('span');label.textContent=t(type)+' +';b.append(icon,label);$('[data-add-grid]').append(b);
    });
    Object.entries(finishes).forEach(([key,color])=>{const b=document.createElement('button');b.type='button';b.dataset.finish=key;b.style.background=color;b.title=t(key);b.setAttribute('aria-label',t(key));$('[data-swatches]').append(b);});
    root.addEventListener('change',e=>{
      const n=e.target;
      if(n.dataset.field){
        const key=n.dataset.field;
        if(key==='van'){state.van=n.value;if(presets[n.value])[state.length,state.width,state.height]=presets[n.value];}
        else if(key==='floor')state.floor=n.value;
        else{if(!n.checkValidity()||n.value===''){n.reportValidity();n.value=state[key];return;}state[key]=Number(n.value);state.van='custom';}
        render();
      }
      if(n.dataset.unit){if(!n.checkValidity()||n.value===''){n.reportValidity();n.value=getSelected()[n.dataset.unit];return;}const u=getSelected();if(u){u[n.dataset.unit]=Number(n.value);render();}}
    });
    root.addEventListener('click',async e=>{
      const b=e.target.closest('button');if(!b)return;
      if(b.dataset.add){add(b.dataset.add);return;}
      if(b.dataset.finish){state.finish=b.dataset.finish;render();return;}
      if(b.dataset.select){selected=Number(b.dataset.select);render();return;}
      const action=b.dataset.action;if(!action)return;
      if(action==='3d'||action==='plan')view=action;
      else if(action==='rotate-left')angle-=30;
      else if(action==='rotate-right')angle+=30;
      else if(action==='reset-view'){angle=145;view='3d';}
      else if(action==='turn'){const u=getSelected();if(u&&u.l<=2300)[u.l,u.w]=[u.w,u.l];else toast(t('turn_limit'));}
      else if(action==='remove'){state.items=state.items.filter(u=>u.id!==selected);selected=state.items[0]?.id;}
      else if(action==='empty'){if(state.items.length&&!confirm(t('empty_confirm')))return;state.items=[];selected=null;}
      else if(action==='starter'){if(state.items.length&&!confirm(t('starter_confirm')))return;state=fresh();selected=2;}
      else if(action==='save'){try{localStorage.setItem('atlas-van-designer-v1',JSON.stringify(state));toast(t('saved'));}catch{toast(t('save_failed'));}return;}
      else if(action==='load'){
        const saved=(()=>{try{return localStorage.getItem('atlas-van-designer-v1');}catch{return null;}})();
        if(saved&&confirm(t('load_saved'))){try{state=validate(JSON.parse(saved));selected=state.items[0]?.id;render();toast(t('loaded'));}catch{toast(t('invalid_plan'));}return;}
        $('[data-import]').click();return;
      }
      else if(action==='download'){
        const blob=new Blob([JSON.stringify(state,null,2)],{type:'application/json'}),url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;a.download='Atlas-Van-Plan.json';root.append(a);a.click();a.remove();setTimeout(()=>URL.revokeObjectURL(url),1000);toast(t('downloaded'));return;
      }
      else if(action==='share'){
        if(config.preview){toast(t('preview_share'));return;}
        const u=new URL(location.href);u.hash='atlas-plan='+encode(state);
        try{await copy(u.href);toast(t('link_copied'));}catch{toast(t('copy_failed'));}return;
      }
      else if(action==='enquiry'){
        const summary=buildSummary();$('[data-enquiry-summary]').value=summary;
        $('[data-email-link]').href='mailto:'+config.email+'?subject='+encodeURIComponent(t('email_subject'))+'&body='+encodeURIComponent(summary);
        $('[data-enquiry-dialog]').showModal();return;
      }
      else if(action==='close-dialog'){$('[data-enquiry-dialog]').close();return;}
      else if(action==='copy-summary'){try{await copy(buildSummary());toast(t('summary_copied'));}catch{toast(t('copy_failed'));}return;}
      render();
    });
    $('[data-import]').addEventListener('change',async e=>{
      const file=e.target.files[0];if(!file)return;
      try{if(file.size>30000)throw Error('size');const parsed=validate(JSON.parse(await file.text()));if(state.items.length&&!confirm(t('import_confirm')))return;state=parsed;selected=state.items[0]?.id;render();toast(t('loaded'));}catch{toast(t('invalid_plan'));}finally{e.target.value='';}
    });
    const svgPoint=e=>{const pt=svg.createSVGPoint();pt.x=e.clientX;pt.y=e.clientY;return pt.matrixTransform(svg.getScreenCTM().inverse());};
    svg.addEventListener('pointerdown',e=>{
      const g=e.target.closest('[data-id]');if(!g)return;selected=Number(g.dataset.id);const u=getSelected();
      if(view==='plan'){e.preventDefault();const pos=svgPoint(e);drag={id:u.id,px:pos.x,py:pos.y,x:u.x,y:u.y};svg.setPointerCapture(e.pointerId);}
      render();
    });
    svg.addEventListener('pointermove',e=>{
      if(!drag)return;const u=state.items.find(x=>x.id===drag.id),pt=svgPoint(e);
      u.x=Math.max(0,Math.min(Math.max(0,state.length-u.l),Math.round((drag.x+(pt.x-drag.px)/projection.scale)/10)*10));
      u.y=Math.max(0,Math.min(Math.max(0,state.width-u.w),Math.round((drag.y+(pt.y-drag.py)/projection.scale)/10)*10));
      render();
    });
    svg.addEventListener('pointerup',()=>{drag=null;});svg.addEventListener('pointercancel',()=>{drag=null;});svg.addEventListener('lostpointercapture',()=>{drag=null;});
    svg.addEventListener('keydown',e=>{
      const g=e.target.closest('[data-id]');if(!g)return;const u=state.items.find(x=>x.id===Number(g.dataset.id));selected=u.id;
      if(e.key==='Enter'||e.key===' '){e.preventDefault();render();return;}
      const delta=e.shiftKey?100:10;
      if(['ArrowLeft','ArrowRight','ArrowUp','ArrowDown'].includes(e.key)){e.preventDefault();if(e.key==='ArrowLeft')u.x-=delta;if(e.key==='ArrowRight')u.x+=delta;if(e.key==='ArrowUp')u.y-=delta;if(e.key==='ArrowDown')u.y+=delta;u.x=Math.max(0,Math.min(Math.max(0,state.length-u.l),u.x));u.y=Math.max(0,Math.min(Math.max(0,state.width-u.w),u.y));render();}
    });
    const picker=$('[data-product-picker]');
    const updateProduct=()=>{
      const v=productVariants().find(v=>String(v.id)===picker.value),a=$('[data-product-link]');
      if(!v){$('[data-product-price]').textContent=t('check_price');a.href='https://www.atlasdistributions.co.uk/products/fridges';return;}
      $('[data-product-price]').textContent=formatMoney(v.price)+(v.available?'':' · '+t('unavailable'));
      a.href='https://www.atlasdistributions.co.uk/products/'+config.product.handle+'?variant='+v.id;
    };
    productVariants().forEach(v=>{const o=document.createElement('option');o.value=v.id;o.textContent=v.title;picker.append(o);});
    if(!productVariants().length){const o=document.createElement('option');o.textContent=t('check_price');picker.append(o);}
    const first=productVariants().find(v=>v.title==='50L / Black')||productVariants()[0];if(first)picker.value=first.id;
    picker.addEventListener('change',updateProduct);updateProduct();render();
    window.addEventListener('hashchange',()=>{
      if(!root.isConnected)return;
      try{const match=location.hash.match(/^#atlas-plan=([\w+/=]+)$/);if(match&&match[1].length<18000){state=validate(decode(match[1]));selected=state.items[0]?.id;render();}}catch{toast(t('invalid_plan'));}
    });
  };
  const boot=scope=>scope.querySelectorAll('[data-atlas-designer]').forEach(initialise);
  boot(document);
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atlas-van-mats"]) return;
  try {
    
document.querySelectorAll('[data-atlas-mats]').forEach(root=>{
  const form=root.querySelector('[data-mat-filters]'),make=root.querySelector('[data-mat-make]'),model=root.querySelector('[data-mat-model]');
  const limitModels=()=>Array.from(model.options).forEach(option=>{option.hidden=Boolean(option.value&&make.value&&option.dataset.make!==make.value);option.disabled=option.hidden;});
  limitModels();
  make.addEventListener('change',()=>{model.value='';limitModels();});
  model.addEventListener('change',()=>{const option=model.selectedOptions[0];if(option.dataset.make){make.value=option.dataset.make;limitModels();}});
  form.addEventListener('submit',event=>{event.preventDefault();const tags=[make.value,model.value].filter(Boolean);const url=new URL(root.dataset.baseUrl,location.origin);if(tags.length)url.pathname+='/'+tags.map(encodeURIComponent).join('+');for(const [key,value] of new FormData(form)){if(String(value).trim())url.searchParams.set(key,value);}location.assign(url.href);});
  root.querySelector('[data-mat-sort]').addEventListener('change',()=>form.requestSubmit());
  root.querySelectorAll('[data-mat-view]').forEach(button=>button.addEventListener('click',()=>{root.classList.toggle('atlas-mats--list',button.dataset.matView==='list');root.querySelectorAll('[data-mat-view]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));}));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
